<template>
    <page title="licenseTitle">
        <template #pageContainer>
            <v-btn
                class="mr-4"
                :disabled="loading"
                @click="getLicense">
                {{ $t(`text.licenseButton`) }}
            </v-btn>

            <spinner :loading="loading"></spinner>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import licenseActions from '../store/actions/license';
import namespace from '../store/namespace';

import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

export default {
	name: 'License',
	components: {
		Page,
		Spinner,
	},
	data() {
		return {
			loading: false,
		};
	},
	computed: {
		...mapGetters(namespace.ORGANIZATION, ['Organization']),
	},
	methods: {
		...mapActions(namespace.LICENSE, [licenseActions.GET_LICENSE]),
		async getLicense() {
			this.loading = true;
			const licenseRequest = {
				organizationId: this.Organization,
			};

			try {
				await this.GET_LICENSE(licenseRequest);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
